import { render, staticRenderFns } from "./CompanyResultPeriodsModal.vue?vue&type=template&id=276bfc08&scoped=true"
import script from "./CompanyResultPeriodsModal.vue?vue&type=script&lang=js"
export * from "./CompanyResultPeriodsModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyResultPeriodsModal.vue?vue&type=style&index=0&id=276bfc08&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276bfc08",
  null
  
)

export default component.exports